import { useMeQuery, usePlatformSettingsQuery, useSetPlatformSettingMutation } from '@platform/state/api';
import { useFailToast } from '../system/useFailToast';

/**
 * Налаштування платформи для сторінок «Загальне» й «Способи входу» (GET /platform/settings): значення ключа, чи може користувач змінювати
 * (лише адміністратор платформи) і збереження ключа (PUT /platform/settings/{key}; об'єкт зливається з поточним значенням на сервері).
 */
export function usePlatformSetting(key: string) {
  const { data: me } = useMeQuery();
  const { data: settings } = usePlatformSettingsQuery();
  const [save, state] = useSetPlatformSettingMutation();
  const fail = useFailToast();
  return {
    value: settings?.[key],
    loaded: !!settings,
    canEdit: me?.globalRole === 'Platform admin',
    saving: state.isLoading,
    save: (value: unknown) => { save({ key, value }).unwrap().catch(fail); },
  };
}
